module.exports = __webpack_public_path__ + "static/img/deep_wrinkles-01.e61999d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/deep_wrinkles-01.jpg
// module id = 258
// module chunks = 1